import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Button,
    Checkbox, Chip,
    Grid,
    ListItemText,
    MenuItem,
    Paper,
    TextField,
    Typography,
    useTheme,
    Tooltip
} from "@mui/material";
import * as Yup from 'yup';
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import '../../style/SalesMarketing.css';
import {useNavigate, useParams} from "react-router-dom";
import {CancelRounded, ExpandMoreRounded, InfoRounded, LibraryAddRounded} from '@mui/icons-material';
import {useContext, useEffect, useState} from "react";
import SubPeriods from "../../component/SubPeriods";
import Ancillaries from "./sections/Ancillaries";
import EarlyBookings from "./sections/EarlyBookings";
import {usePromoActions} from "../../service/usePromoActions";
import {useProductCodeActions} from "../../service/useProductCodeActions";
import {useSubscriptionActions} from "../../service/useSubscriptionActions";
import PromoCreationModal from "./modals/PromoCreationModal";
import {
    INTEGER_6_DIGIT_REG_EXP,
    PROMO_STATUS_ACTIVE,
    PROMO_STATUS_DISABLED,
    PROMO_STATUS_DRAFT,
    PROMO_TYPOLOGY_CREDIT_CARD,
    PROMO_TYPOLOGY_SHORT_TERM,
    PROMO_TYPOLOGY_SUBSCRIPTION,
    PROMO_VISIBILITY_PRIVATE,
    PROMO_VISIBILITY_PUBLIC
} from "../../component/Constants";
import dayjs from "dayjs";
import {useLookupActions} from "../../service/useLookupActions";
import {useStatusValuesPromo} from "../../component/useStatusValuesPromo";
import {yupResolver} from "@hookform/resolvers/yup";
import {Controller, useFieldArray, useForm} from "react-hook-form";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import AdvancedDmsSelector from "../../component/AdvancedDmsSelector/AdvancedDmsSelector";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {PromoDetail} from "./Constants/PromoInterfaces";
import ProductAndDateRows from "./sections/ProductAndDateRows";
import BookingAndDiscountRows from "./sections/BookingAndDiscountRows";
import SubscriptionLastRows from "./sections/SubscriptionLastRows";
import PromoAddProductModal from "./modals/PromoAddProductModal";
import {
    UserLegalEntitiesOrDealersInputGroup, preselectSingleEntity
} from "../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {floatToIntCurrency, intToFloatCurrency} from "../../component/Utils";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        },
    },
};

const PromoCreateOrUpdatePage = () => {
    const {promoId} = useParams();
    const isUpdate = !!promoId;
    const {globalData} = useContext(GlobalContext);
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();
    const [promo, setPromo] = useState<PromoDetail>();
    const [productCodes, setProductCodes] = useState<any>([]);
    const [productCodesMap, setProductCodesMap] = useState<any>();
    const [selectedProduct, setSelectedProduct] = useState<any>({
        startDate: null,
        endDate: null,
        name: "",
        description: ""
    });
    const [acrisCodes, setAcrisCodes] = useState<any>([]);
    const [lmsList, setLmsList] = useState<any>([]);
    const [dropDmsList, setDropDmsList] = useState<any>([]);
    const [ancillaryNameList, setAncillaryNameList] = useState<any>([]);
    const [ancillaryIndex, setAncillaryIndex] = useState(0);
    const [ancillaries, setAncillaries] = useState<any>([]);
    const [ancillariesErrorMessage, setAncillariesErrorMessage] = useState<any>();
    const [earlyBookingsIndex, setEarlyBookingsIndex] = useState(0);
    const [earlyBookings, setEarlyBookings] = useState<any>([]);
    const [earlyBookingsErrorMessage, setEarlyBookingsErrorMessage] = useState<any>([]);
    const {getPromoById, createPromo, updatePromo} = usePromoActions();
    const {getRatePlanInfoByProductCode, getCategoriesBySegmentCode} = useLookupActions();
    const {listProductCode, listSegment} = useProductCodeActions();
    const {getStatusLabel} = useStatusValuesPromo();
    const {getSubscriptions, getSubscriptionById} = useSubscriptionActions();
    const [firstLoading, setFirstLoading] = useState(true);
    const theme = useTheme();
    const errorColor = theme.palette.error.main;
    const {dispatchGlobalData} = useContext(GlobalContext);
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const [disabledConfirm, setDisabledConfirm] = useState(false);
    const [openProductCodeField, setOpenProductCodeField] = useState<boolean>(false);
    const [openAddProductModal, setOpenAddProductModal] = useState<boolean>(false);
    const [categories, setCategories] = useState<any[]>([]);
    const [segments, setSegments] = useState<any[]>([]);
    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    // const [productsDates, setProductsDates] = useState<any[]>([]);
    const [selectedSubscription, setSelectedSubscription] = useState({
        sku: '',
        name: '',
        activableStartDate: null,
        activableEndDate: null,
        dms: [] as any[]
    });
    const [selectedIds, setSelectedIds] = useState<any>(new Map())

    const removeFromSubscription = ['bookingStartDate', 'bookingEndDate', 'pickupStartDate', 'pickupEndDate', 'dropDmsList','acrissCodeList','lmsList', 'discountPercentage', 'discountAmount', 'maxBookings', 'maxUserBookings', 'minimumDurationForFreeDays', 'freeDays', 'minimumDuration', 'binCode'];
    const removeFromShortTerm = ['binCode', 'numberOfMonths', 'monthlyStartDate', 'monthlyEndDate', 'yearlyFeeDiscountPercentage', 'yearlyFeeDiscountAmount', 'monthlyFeeDiscountPercentage', 'monthlyFeeDiscountAmount', 'subscriptionplanId', 'sku'];
    const removeFromCreditCard = ['subscriptionplanId', 'sku', 'numberOfMonths', 'monthlyStartDate','monthlyEndDate', 'yearlyFeeDiscountPercentage', 'yearlyFeeDiscountAmount', 'monthlyFeeDiscountPercentage', 'monthlyFeeDiscountAmount', 'acrissCodeList', 'lmsList', 'dropDmsList'];

    const statuses = [
        {
            key: PROMO_STATUS_ACTIVE,
            value: getStatusLabel(PROMO_STATUS_ACTIVE)
        },
        {
            key: PROMO_STATUS_DISABLED,
            value: getStatusLabel(PROMO_STATUS_DISABLED)
        },
        {
            key: PROMO_STATUS_DRAFT,
            value: getStatusLabel(PROMO_STATUS_DRAFT)
        }
    ]

    const visibility = [
        {
            key: PROMO_VISIBILITY_PRIVATE,
            value: getStatusLabel(PROMO_VISIBILITY_PRIVATE)
        },
        {
            key: PROMO_VISIBILITY_PUBLIC,
            value: getStatusLabel(PROMO_VISIBILITY_PUBLIC)
        }
    ];

    const typology = [
        {
            key: PROMO_TYPOLOGY_SHORT_TERM,
            value: getStatusLabel(PROMO_TYPOLOGY_SHORT_TERM)
        },
        {
            key: PROMO_TYPOLOGY_CREDIT_CARD,
            value: getStatusLabel(PROMO_TYPOLOGY_CREDIT_CARD)
        },
        {
            key: PROMO_TYPOLOGY_SUBSCRIPTION,
            value: getStatusLabel(PROMO_TYPOLOGY_SUBSCRIPTION)
        }
    ];

    useEffect(() => {
        getCategoriesBySegmentCode(undefined).then((res: any) => {
            setCategories(res);
        });
        listSegment().then((res: any) => {
            setSegments(res);
        });
    }, []);




    const initialValues: PromoDetail =
        {
            id: null,
            tenantId: '',
            dealerId: '',
            statusCode: PROMO_STATUS_DRAFT,
            productCode: '',
            typology: PROMO_TYPOLOGY_SHORT_TERM,
            acrissCodeList: [],
            lmsList: [],
            dropDmsList: [],
            promoCode: '',
            discountPercentage: '',
            discountAmount: '',
            bookingStartDate: null,
            bookingEndDate: null,
            pickupStartDate: null,
            pickupEndDate: null,
            description: '',
            minimumDuration: '',
            maxBookings: '',
            maxUserBookings: '',
            freeDays: '',
            minimumDurationForFreeDays: '',
            binCode: [],
            subperiodList: [],
            visibility: '',
            subscriptionplanId: '',
            sku: '',
            numberOfMonths: '',
            monthlyStartDate: null,
            monthlyEndDate: null,
            yearlyFeeDiscountPercentage: '',
            yearlyFeeDiscountAmount: '',
            monthlyFeeDiscountPercentage: '',
            monthlyFeeDiscountAmount: ''
        };

    const baseValidator = {
        tenantId: Yup.string().nullable().test('testTenant', t('promo.createForm.requiredCheck'), (value) => {
            if (globalData?.user?.legalEntities?.length === 1)
                return true;
            return !!value;
        }),
        dealerId: Yup.string().nullable().test('testDealer', t('promo.createForm.requiredCheck'), (value) => {
            if (globalData?.user?.dealers?.length === 1)
                return true;
            return !!value;
        }),
        statusCode: Yup.string().required(t('promo.createForm.requiredCheck')),
        productCode: Yup.mixed().when('typology', {
            is: PROMO_TYPOLOGY_CREDIT_CARD,
            then: Yup.array().min(1, t('promo.createForm.requiredCheck')),
            otherwise: Yup.string().required(t('promo.createForm.requiredCheck'))
        }),
        typology: Yup.string().required(t('promo.createForm.requiredCheck')),
        visibility: Yup.string().required(t('promo.createForm.requiredCheck')),
        acrissCodeList: Yup.array().when('typology', {
            is:PROMO_TYPOLOGY_SHORT_TERM,
            then: Yup.array().min(1, t('promo.createForm.requiredCheck')),
            otherwise: Yup.array().min(0)
        }),
        lmsList: Yup.array().when('typology', {
            is: PROMO_TYPOLOGY_SHORT_TERM,
            then: Yup.array().min(1, t('promo.createForm.requiredCheck')),
            otherwise: Yup.array().min(0)
        }),
        dropDmsList: Yup.array().when('typology', {
            is: PROMO_TYPOLOGY_SHORT_TERM,
            then: Yup.array().min(1, t('promo.createForm.requiredCheck')),
            otherwise: Yup.array().min(0),
        }),
        promoCode: Yup.string().when('typology', {
            is: PROMO_TYPOLOGY_CREDIT_CARD,
            then: Yup.string().nullable(),
            otherwise: Yup.string().required(t('promo.createForm.requiredCheck')).min(10, t('promo.createForm.promoCodeLength')).max(15, t('promo.createForm.promoCodeLength'))
        }),
        bookingStartDate: Yup.date().when('typology', {
            is: PROMO_TYPOLOGY_SUBSCRIPTION,
            then: Yup.date().nullable(),
            otherwise: Yup.date().required(t('promo.createForm.requiredCheck')).typeError(t('promo.createForm.invalidDate')).test("testBookingStartDate", t('promo.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.bookingEndDate && value <= context.parent.bookingEndDate)
            }).test("testBookingStartDateInsideProductDates", t('promo.createForm.bookingStartDateCheck'), (value, context) => {
                //if (productsDates.length === 0)
                if(watch("typology")!==PROMO_TYPOLOGY_CREDIT_CARD)
                    return (value && selectedProduct.endDate && selectedProduct.startDate && value <= selectedProduct.endDate && value >= selectedProduct.startDate);
                return true;
                //return productsDates.every((pd) => value && value >= pd.startDate && value <= pd.endDate)
            })
        }),
        bookingEndDate: Yup.date().when('typology', {
            is: PROMO_TYPOLOGY_SUBSCRIPTION,
            then: Yup.date().nullable(),
            otherwise: Yup.date().required(t('promo.createForm.requiredCheck')).typeError(t('promo.createForm.invalidDate')).test("testBookingEndDate", t('promo.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.bookingStartDate && value >= context.parent.bookingStartDate)
            }).test("testBookingStartDateInsideProductDates", t('promo.createForm.bookingEndDateCheck'), (value, context) => {
                //if (productsDates.length === 0)
                if(watch("typology")!==PROMO_TYPOLOGY_CREDIT_CARD)
                    return (value && selectedProduct.startDate && selectedProduct.endDate && value <= selectedProduct.endDate && value >= selectedProduct.startDate);
                return true;
                //return productsDates.every((pd) => value && value >= pd.startDate && value <= pd.endDate)
            })
        }),
        pickupStartDate: Yup.date().when('typology', {
            is: PROMO_TYPOLOGY_SUBSCRIPTION,
            then: Yup.date().nullable(),
            otherwise: Yup.date().required(t('promo.createForm.requiredCheck')).test("testPickupStartDate", t('promo.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.pickupEndDate && value <= context.parent.pickupEndDate)
            }).typeError(t('promo.createForm.invalidDate'))
        }),
        pickupEndDate: Yup.date().when('typology', {
            is: PROMO_TYPOLOGY_SUBSCRIPTION,
            then: Yup.date().nullable(),
            otherwise: Yup.date().required(t('promo.createForm.requiredCheck')).test("testPickupEndDate", t('promo.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.pickupStartDate && value >= context.parent.pickupStartDate)
            }).typeError(t('promo.createForm.invalidDate'))
        }),
        description: Yup.string().nullable(),
        minimumDuration: Yup.string().nullable(),
        maxBookings: Yup.string().nullable(),
        freeDays: Yup.string().nullable(),
        minimumDurationForFreeDays: Yup.string().nullable(),
        binCode: Yup.array().when('typology', {
            is: PROMO_TYPOLOGY_CREDIT_CARD,
            then: Yup.array().min(1, t('promo.createForm.requiredCheck')).test("testBinCodeRegex", t('promo.createForm.onlySixNumbers'), (value, context) => {
                return ((!!value && value.length > 0 && value.every(v => INTEGER_6_DIGIT_REG_EXP.test(v))) || !context.parent.isCreditCardPromo)
            }),
            otherwise: Yup.array().min(0)
        }),
        subperiodList: Yup.array()
            .of(
                Yup.object().shape({
                    startDate: Yup.date().nullable().required(t('promo.createForm.requiredCheck')).test('a', t('promo.createForm.dateRange'), (value, context) => {
                        return (!!value && !!context.parent.endDate) && value <= context.parent.endDate;
                    }).test('b', t('promo.createForm.validSubperiod'), (value) => {
                        let startDate: any = watch('pickupStartDate');
                        return (!!value && !!startDate) && (dayjs(value).startOf('day') >= dayjs(startDate).startOf('day'));
                    }).typeError(t('promo.createForm.invalidDate')),
                    endDate: Yup.date().nullable().required(t('promo.createForm.requiredCheck')).test('a', t('promo.createForm.dateRange'), (value, context) => {
                        return (!!value && !!context.parent.startDate) && value >= context.parent.endDate;
                    }).test('b', t('promo.createForm.validSubperiod'), (value) => {
                        let endDate: any = watch('pickupEndDate');
                        return (!!value && !!endDate) && (dayjs(value).endOf('day') <= dayjs(endDate).endOf('day'));
                    }).typeError(t('promo.createForm.invalidDate')),
                })
            )
            .nullable(),
            monthlyStartDate:Yup.date().when('typology', {
                is: PROMO_TYPOLOGY_SUBSCRIPTION,
                then: Yup.date().nullable().typeError(t('promo.createForm.invalidDate')).required(t('promo.createForm.requiredCheck')),
                otherwise: Yup.date().nullable()
            }),
            monthlyEndDate:Yup.date().when('typology', {
                is: PROMO_TYPOLOGY_SUBSCRIPTION,
                then: Yup.date().nullable().typeError(t('promo.createForm.invalidDate')).required(t('promo.createForm.requiredCheck')),
                otherwise: Yup.date().nullable()
            })
    };

    const subscriptionValidator = {
        yearlyFeeDiscountPercentage: Yup.string().nullable().test('test', t('promo.createForm.percentageCheck'), (value) => {
            if (!value)
                return true;
            return (!!value && parseInt(value) >= 0 && parseInt(value) <= 100)
        }),
        monthlyFeeDiscountPercentage: Yup.string().nullable().test('test', t('promo.createForm.percentageCheck'), (value) => {
            if (!value)
                return true;
            return (!!value && parseInt(value) >= 0 && parseInt(value) <= 100)
        }),
        numberOfMonths: Yup.string().nullable().test('test', t('promo.createForm.requiredCheck'), (value, context) => {
            if(context.parent.typology == PROMO_TYPOLOGY_SUBSCRIPTION) {
                if(!!context.parent.monthlyFeeDiscountPercentage || !!context.parent.monthlyFeeDiscountAmount)
                    return (!!value && (!!context.parent.monthlyFeeDiscountPercentage || !!context.parent.monthlyFeeDiscountAmount))
            }
            return true;
        }),
        subscriptionplanId: Yup.string().when('typology', {
            is: PROMO_TYPOLOGY_SUBSCRIPTION,
            then: Yup.string().required(t('promo.createForm.requiredCheck')),
            otherwise: Yup.string().nullable()
        }),
    }


    useEffect(() => {
        if (promo && isUpdate) {
            for (var key in promo) {
                setValue(key as keyof PromoDetail, promo[key as keyof PromoDetail] ? promo[key as keyof PromoDetail] : initialValues[key as keyof PromoDetail]);
                if (key === 'discountAmount')
                    setValue('discountAmount', promo.discountAmount ? intToFloatCurrency(promo.discountAmount) : "");
                if (key === 'maxBookings')
                    setValue('maxBookings', promo.maxBookings);
                if (key === 'maxUserBookings')
                    setValue('maxUserBookings', promo.maxUserBookings);
                if (key === 'yearlyFeeDiscountAmount')
                    setValue('yearlyFeeDiscountAmount', promo.yearlyFeeDiscountAmount ? intToFloatCurrency(promo.yearlyFeeDiscountAmount) : '');
                if (key === 'monthlyFeeDiscountAmount')
                    setValue('monthlyFeeDiscountAmount', promo.monthlyFeeDiscountAmount ? intToFloatCurrency(promo.monthlyFeeDiscountAmount) : '');
            }
            if (promo.typology !== PROMO_TYPOLOGY_CREDIT_CARD) {
                setValue('productCode', promo.productCode[0]);
            }
            if (promo.typology === PROMO_TYPOLOGY_SUBSCRIPTION) {
                let sub = subscriptions.find((s: any) => s.id === promo.subscriptionplanId);
                setSelectedSubscription({
                    name: sub.name,
                    sku: sub.sku,
                    activableEndDate: sub.activableEndDate,
                    activableStartDate: sub.activableStartDate,
                    dms: sub.pickupDms
                })
            }

        }
    }, [promo]);

    const onSubmit = async (values: any) => {

        values = {
            ...values, subperiodList: values.subperiodList.map((sp: any, i: number) => {
                return {
                    startDate: sp.startDate,
                    endDate: sp.endDate,
                    id: i + 1
                };
            })
        }

        if (values.discountAmount !== '') {
            values = {...values, discountAmount: floatToIntCurrency(values.discountAmount)}
        }

        if (values.monthlyFeeDiscountAmount !== '') {
            values = {...values, monthlyFeeDiscountAmount: floatToIntCurrency(values.monthlyFeeDiscountAmount)}
        }

        if (values.yearlyFeeDiscountAmount !== '') {
            values = {...values, yearlyFeeDiscountAmount: floatToIntCurrency(values.yearlyFeeDiscountAmount)}
        }

        let ancs = ancillaries.map((anc: any) => {
            return anc.amount ? {...anc, amount: floatToIntCurrency(anc.amount)} : anc
        });

        if (!Array.isArray(values.productCode)) {
            values = {...values, productCode: [values.productCode]};
        }

        if (values.typology === PROMO_TYPOLOGY_CREDIT_CARD) {
            values = {...values, promoCode: ''}
            removeFromCreditCard.forEach((key: string) => {
                delete values[key]
            });
        }
        if (values.typology === PROMO_TYPOLOGY_SHORT_TERM) {
            removeFromShortTerm.forEach((key: string) => {
                delete values[key]
            });
        }
        if (values.typology === PROMO_TYPOLOGY_SUBSCRIPTION) {
            removeFromSubscription.forEach((key: string) => {
                delete values[key]
            });
        }

        if (values.monthlyEndDate){
            values.monthlyEndDate = dayjs(values.monthlyEndDate).hour(23).minute(59).second(59);
        }
        if (checkList()) {
            if (isUpdate) {
                let data = await updatePromo({...values}, ancs, earlyBookings);
                showResult(data);
            } else {
                let data = await createPromo({...values}, ancs, earlyBookings);
                showResult(data);
            }
        }
    }

    const showResult = (data: any) => {
        if (data && data.status === 'OK') {
            // show modal with confirm
            setOpenCreationModal(true);
        } else {
            // show snackbar with error
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(`promo.errors.${data.message}`),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }
    }

    const {handleSubmit, control, setValue, watch, reset, setError, clearErrors, formState} = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(Yup.object({...baseValidator, ...subscriptionValidator}))
    });



    const {fields, append, remove} = useFieldArray({
        control,
        name: "subperiodList"
    });

    const isAllAcrissSelected =
        acrisCodes.length > 0 && watch("acrissCodeList").length === acrisCodes.length;

    function checkList() {
        let result = {isOk: true};
        checkAncillaries(result);
        checkEarlyBookings(result);
        return result.isOk;
    }

    function checkAncillaries(check: any) {
        let copyErrMsg = {...ancillariesErrorMessage};
        ancillaries.forEach((s: any) => {
            if (s.name === "") {
                copyErrMsg["name" + s.id] = t('promo.createForm.requiredCheck');
                check.isOk = false;
            }
            if (s.discount === "" && s.amount === "") {
                copyErrMsg["discount" + s.id] = t('promo.createForm.requiredCheck');
                copyErrMsg["amount" + s.id] = t('promo.createForm.requiredCheck');
                check.isOk = false
            }
        })
        setAncillariesErrorMessage(copyErrMsg);
    }

    function checkEarlyBookings(check: any) {
        let copyErrMsg = {...earlyBookingsErrorMessage};
        earlyBookings.forEach((s: any) => {
            if (!s.early) {
                copyErrMsg["early" + s.id] = t('promo.createForm.requiredCheck');
                check.isOk = false;
            }
            if (!s.discount) {
                copyErrMsg["discount" + s.id] = t('promo.createForm.requiredCheck');
                check.isOk = false
            }
        })
        setEarlyBookingsErrorMessage(copyErrMsg);
    }

    const isValidProduct = (pc: any) => {
        if (productCodesMap.get(pc).status == 'X' || dayjs(productCodesMap.get(pc).endDate).endOf("day").toDate() < new Date() || dayjs(productCodesMap.get(pc).startDate).startOf("day").toDate() > new Date()) {
            setDisabledConfirm(true)
            setError('productCode', {type: 'custom', message: t(`promo.errors.product`)})
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(`promo.errors.inactiveProduct`),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: false,
                    }
                }
            });
        } else {
            setDisabledConfirm(false);
            clearErrors('productCode')
        }
    }

    function clearFields(){
        setSelectedSubscription({
            sku: '',
            name: '',
            activableStartDate: null,
            activableEndDate: null,
            dms: [] as any[]
        });
        setValue("sku", "")
        setValue("subscriptionplanId", "")
    }

    useEffect(() => {
        clearErrors('productCode')
        if (watch('typology') === PROMO_TYPOLOGY_SUBSCRIPTION) {
            if (!firstLoading) {
                clearFields();
            }
        }
        if (watch("productCode") && !Array.isArray(watch("productCode")) && productCodesMap) {
            let productCode = watch('productCode');
            isValidProduct(watch('productCode'));
            if (typeof productCode === 'string' && watch('typology') !== PROMO_TYPOLOGY_CREDIT_CARD) {

                setSelectedProduct({
                    startDate: dayjs(productCodesMap.get(watch("productCode")).startDate).startOf("day").toDate(),
                    endDate: dayjs(productCodesMap.get(watch("productCode")).endDate).endOf("day").toDate(),
                    name: productCodesMap.get(watch("productCode")).name,
                    description: productCodesMap.get(watch("productCode")).description,
                })
                // retrieve lms, acris, ancillaries by productCode
                getRatePlanInfoByProductCode(productCode).then(res => {
                    let locationsExt = res.locationsExt;
                    let carGroups = res.carGroups;
                    let ancillarieNames = res.ancillaries;
                    if (res && locationsExt && carGroups && ancillarieNames) {
                        if (!isUpdate || !firstLoading) {
                            // Reset prev values
                            setValue("acrissCodeList", []);
                            setValue("lmsList", []);
                            setValue("dropDmsList", []);
                            setAncillaries([]);
                        }

                        setAcrisCodes(carGroups);
                        if (!isUpdate) {
                            // on creation select all items
                            setValue("acrissCodeList", carGroups);
                        }
                        setLmsList(locationsExt);
                        setDropDmsList(locationsExt);
                        setAncillaryNameList(ancillarieNames);
                        setFirstLoading(false);
                    }
                })
            }
        }
        let productCodes = watch('productCode');
        if (Array.isArray(productCodes) && productCodes.length > 0) {
            isValidProduct(productCodes[0]);

            setAncillaryNameList([]);
            productCodes.forEach((pc: string) => {
                getRatePlanInfoByProductCode(pc).then(res => {
                    setAncillaryNameList((prev: any) => {
                        let arr = [...prev, ...res.ancillaries];
                        return arr.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i);
                    });
                })
            });

        }


    }, [watch("productCode")]);

    function addAncillary() {
        setAncillaries([...ancillaries, {id: ancillaryIndex + 1, name: "", discount: "", amount: "", ida:"", code:""}]);
        setAncillaryIndex(ancillaryIndex + 1);
    }

    function addEarlyBooking() {
        setEarlyBookings([...earlyBookings, {id: earlyBookingsIndex + 1, early: "", discount: ""}]);
        setEarlyBookingsIndex(earlyBookingsIndex + 1);
    }


    useEffect(() => {
        getSubscriptions({offset: 0, limit: 10000}).then((res: any) => {
            setSubscriptions(res.content);
        });
    }, []);

    useEffect(() => {
        preselectSingleEntity(globalData, setValue);
    }, [globalData, setValue]);

    useEffect(() => {
        setValue("productCode", []);
        setSelectedProduct({});
        setValue("acrissCodeList", []);
        setValue("lmsList", []);
        setValue("dropDmsList", []);
        setAncillaries([]);
        // Retrieve products
        listProductCode({offset: 0, limit: 10000}).then(response => {
            let products = response.content;
            if (products.length > 0) {
                setProductCodes(products.filter((t:any) => t.tenantId === watch('tenantId')  && t.dealerId === watch('dealerId')).map(p => p.productCode));
                let productsMap = new Map<string, any>();
                products.forEach(p => {
                    productsMap.set(p.productCode, {
                        startDate: p.startDate,
                        endDate: p.endDate,
                        name: p.name,
                        description: p.description,
                        status: p.statusCode
                    })
                })
                setProductCodesMap(productsMap);
                // Retrieve promo
                if (promoId && isUpdate) {
                    getPromoById(promoId).then(promoFound => {
                        if (promoFound.monthlyStartDate) promoFound.monthlyStartDate = dayjs(promoFound.monthlyStartDate).hour(0).minute(0).second(0);
                        setPromo(promoFound);
                        if (promoFound.typology !== PROMO_TYPOLOGY_CREDIT_CARD) {
                            setSelectedProduct({
                                startDate: dayjs(productsMap.get(promoFound.productCode[0]).startDate).startOf("day").toDate(),
                                endDate: dayjs(productsMap.get(promoFound.productCode[0]).endDate).endOf("day").toDate(),
                                name: productsMap.get(promoFound.productCode[0]).name,
                                description: productsMap.get(promoFound.productCode[0]).description,
                            })
                        }
                        setAncillaries(promoFound?.ancillaryList.map((anc: any) => {
                            return anc.amount ? {...anc, amount: intToFloatCurrency(anc.amount)} : anc
                        }));
                        setAncillaryIndex(promoFound?.ancillaryList?.length);
                        setEarlyBookings(promoFound?.earlyBookingList);
                        setEarlyBookingsIndex(promoFound?.earlyBookingList?.length);
                    });
                }
            }
        });
    }, [watch('tenantId'), watch('dealerId')]);

    return (
        <>
            <SectionHeader
                title={t(isUpdate ? 'promo.updateHeader.title' : 'promo.createHeader.title')}
                subtitle={t('promo.createHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <form onSubmit={handleSubmit(data => {
                    onSubmit({...data});
                }, errors => console.log(errors))} noValidate>
                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <UserLegalEntitiesOrDealersInputGroup control={control} disabled={isUpdate}/>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="statusCode"
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label={t('promo.status')}
                                        disabled={!isUpdate}
                                        select
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        {statuses?.map((a) => (
                                            <MenuItem key={a.key} value={a.key}>
                                                {a.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="visibility"
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label={t('promo.visibility')}
                                        select
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        {visibility?.map((a) => (
                                            <MenuItem key={a.key} value={a.key}>
                                                {a.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="typology"
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label={t('promo.typology')}
                                        select
                                        value={field.value}
                                        onChange={(e) => {
                                            if (e.target.value === PROMO_TYPOLOGY_CREDIT_CARD) {
                                                setValue('productCode', []);
                                                setSelectedProduct({});
                                            } else if (watch('typology') === PROMO_TYPOLOGY_CREDIT_CARD) {
                                                setValue('productCode', '');
                                                setSelectedProduct({})
                                            }
                                            field.onChange(e.target.value);
                                        }}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        {typology?.map((a: any) => (
                                            <MenuItem key={a.key} value={a.key}>
                                                {a.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="productCode"
                                render={({field, fieldState}) => (watch('typology') === PROMO_TYPOLOGY_CREDIT_CARD ? (
                                        <TextField
                                            fullWidth
                                            required
                                            label={t('promo.productCodes')}
                                            select
                                            disabled={watch("tenantId") === "" || watch("dealerId") === ""}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            SelectProps={{
                                                MenuProps: MenuProps,
                                                renderValue: (selected: any) => selected.map((s: any, i: number) =>
                                                    <Chip label={s} key={i} deleteIcon={
                                                        <CancelRounded
                                                            onMouseDown={(event: any) => event.stopPropagation()}
                                                        />
                                                    } onDelete={() => {
                                                        let productCodes = watch('productCode');
                                                        if (productCodes && Array.isArray(productCodes))
                                                            setValue('productCode', productCodes.filter((pc: any) => pc !== s));
                                                    }}/>),
                                                onOpen: () => {
                                                    setOpenAddProductModal(true);
                                                },
                                                open: false,
                                                multiple: true
                                            }}
                                        >
                                            {productCodes?.map((a: any) => (
                                                <MenuItem key={a} value={a}>
                                                    {a}
                                                </MenuItem>
                                            ))}
                                        </TextField>) : (
                                        <Autocomplete
                                            id="productCode"
                                            value={Array.isArray(field.value) ? field.value[0] : field.value}
                                            onChange={(e, newVal) => {
                                                let val = newVal ? newVal.split(' -')[0] : '' ;
                                                field.onChange(val)
                                            }}
                                            options={productCodes.sort().map((pc:string)=>{
                                                return `${pc} - ${productCodesMap.get(pc).name}`
                                            })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('promo.productCode')}
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                    required
                                                    disabled={watch("tenantId") === "" || watch("dealerId") === ""}
                                                />
                                            )}
                                        />)
                                )}/>
                        </Grid>
                        <ProductAndDateRows disabledConfirm={disabledConfirm} selectedProduct={selectedProduct}
                                            watch={watch} control={control} setValue={setValue}/>
                        {(watch('typology') === PROMO_TYPOLOGY_SUBSCRIPTION) &&
                            <>
                                <Grid item xs={3}>
                                    <Controller
                                        control={control}
                                        name="subscriptionplanId"
                                        render={({field, fieldState}) => (
                                            <TextField
                                                fullWidth
                                                required
                                                select
                                                label={t('promo.subscription')}
                                                value={field.onChange}
                                                onChange={(e) => {
                                                    // field.onChange(e.target.value);
                                                    let sub: any = subscriptions.find((s: any) => s.id === e.target.value);
                                                    setValue('sku', sub.sku);
                                                    setValue('subscriptionplanId', sub.id);
                                                    setSelectedSubscription({
                                                        name: sub.name,
                                                        sku: sub.sku,
                                                        activableEndDate: sub.activableEndDate,
                                                        activableStartDate: sub.activableStartDate,
                                                        dms: sub.pickupDms
                                                    })
                                                }}
                                                error={!!fieldState.error}
                                                disabled={!watch('productCode')}
                                                helperText={fieldState.error?.message}
                                                SelectProps={{
                                                    MenuProps: MenuProps,
                                                    renderValue: (selected: any) => selectedSubscription.name
                                                }}
                                            >
                                                {subscriptions?.filter((s: any) => s.productCode === watch('productCode')).map((s: any) => (
                                                    <MenuItem key={s.id} value={s.id}>
                                                        {s.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <Controller
                                        control={control}
                                        name="sku"
                                        render={({field, fieldState}) => (
                                            <TextField
                                                fullWidth
                                                label={t('promo.sku')}
                                                disabled
                                                value={field.value}
                                            />)}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        label={t('promo.subscriptionStartDate')}
                                        value={selectedSubscription.activableStartDate ? dayjs(selectedSubscription.activableStartDate).format("L") : ''}
                                        disabled
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        label={t('promo.subscriptionEndDate')}
                                        value={selectedSubscription.activableEndDate ? dayjs(selectedSubscription.activableEndDate).format("L") : ''}
                                        disabled
                                        fullWidth
                                    />
                                </Grid>
                            </>

                        }
                        {watch('typology') === PROMO_TYPOLOGY_SHORT_TERM &&
                            <Grid item xs={6}>
                                <Controller
                                    control={control}
                                    name="lmsList"
                                    render={({field, fieldState: {error}}) => (
                                        <AdvancedDmsSelector key={lmsList} error={error} required={true}
                                                             disabled={lmsList.length === 0} value={field.value}
                                                             setValue={setValue} fieldName={"lmsList"}
                                                             items={(selectedSubscription && selectedSubscription.dms.length > 0 && watch('typology') === PROMO_TYPOLOGY_SUBSCRIPTION) ? lmsList.filter((lms: any) => selectedSubscription.dms.includes(lms.sapId)) : lmsList}
                                                             label={t('promo.lms')} tenantId={watch('tenantId')}/>
                                    )}/>
                            </Grid>
                        }
                        {watch('typology') === PROMO_TYPOLOGY_SHORT_TERM &&
                            <Grid item xs={6}>
                                <Controller
                                    control={control}
                                    name="dropDmsList"
                                    render={({field, fieldState: {error}}) => (
                                        <AdvancedDmsSelector key={dropDmsList} error={error} required={true}
                                                             disabled={dropDmsList.length === 0} value={field.value}
                                                             setValue={setValue} fieldName={"dropDmsList"}
                                                             items={dropDmsList} label={t('promo.dropDms')} tenantId={watch('tenantId')}/>
                                    )}/>
                            </Grid>
                        }
                        {(watch('typology') === PROMO_TYPOLOGY_SHORT_TERM) &&
                            <Grid item xs={6}>
                                <Controller
                                    control={control}
                                    name="acrissCodeList"
                                    render={({field, fieldState}) => (
                                        <TextField sx={{maxWidth:'50vw'}}
                                            fullWidth
                                            required
                                            disabled={acrisCodes.length === 0}
                                            label={t('promo.acrissCode')}
                                            select
                                            value={field.value}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value[value.length - 1] === "all") {
                                                    setValue("acrissCodeList", field.value.length === acrisCodes.length ? [] : acrisCodes)
                                                } else {
                                                    field.onChange(e)
                                                }
                                            }}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            SelectProps={{
                                                multiple: true,
                                                renderValue: (selected: any) => selected.join(', '),
                                                MenuProps: MenuProps
                                            }}
                                        >
                                            <MenuItem value="all" className={"selectAll"}>
                                                <Checkbox
                                                    color={"accent"}
                                                    checked={isAllAcrissSelected}
                                                    indeterminate={
                                                        field.value.length > 0 && field.value.length < acrisCodes.length
                                                    }
                                                />
                                                <ListItemText className={"selectAllText"}
                                                              primary={t('promo.selectAll')}/>
                                            </MenuItem>
                                            {acrisCodes?.map((a: any) => (
                                                <MenuItem key={a} value={a}>
                                                    <Checkbox color={"accent"}
                                                              checked={(field.value as string[]).indexOf(a) > -1}/>
                                                    <ListItemText primary={a}/>
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                        }
                        {(watch('typology') === PROMO_TYPOLOGY_SUBSCRIPTION) &&
                            <SubscriptionLastRows control={control} setValue={setValue} watch={watch} updateInitialTypology={isUpdate && promo ? promo.typology : undefined } isUpdate={isUpdate}/>
                        }
                        {(watch('typology') === PROMO_TYPOLOGY_CREDIT_CARD) &&
                            <Grid item xs={12}>
                                <Controller
                                    control={control}
                                    name={"binCode"}
                                    render={({field, fieldState: {error}}) => (
                                        <Autocomplete
                                            multiple
                                            clearOnBlur={true}
                                            blurOnSelect={false}
                                            freeSolo
                                            id="binCode"
                                            options={[]}
                                            value={field.value}
                                            onChange={(e, newVal, reason) => field.onChange(newVal)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    required
                                                    label={t('promo.binCodes')}
                                                    placeholder={t('chipList.placeholder')}
                                                    error={error !== undefined}
                                                    helperText={error?.message}
                                                />
                                            )}
                                        />
                                    )}/>
                            </Grid>
                        }
                        {(watch('typology') !== PROMO_TYPOLOGY_SUBSCRIPTION) &&
                            <BookingAndDiscountRows watch={watch} control={control} setValue={setValue}
                                                    isUpdate={isUpdate} updateInitialTypology={isUpdate && promo ? promo.typology : undefined }/>
                        }

                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        {(watch('typology') !== PROMO_TYPOLOGY_SUBSCRIPTION) &&
                            <Grid item xs={12}>
                                <SubPeriods startDate={watch("pickupStartDate")}
                                            endDate={watch("pickupEndDate")}
                                            control={control}
                                            remove={remove}
                                            title={t('promo.subPeriods.title')}
                                            append={append}
                                            fields={fields}
                                            watch={watch}
                                            errors={formState.errors}
                                            fieldName={'subperiodList'}
                                />
                            </Grid>
                        }
                        <Grid item xs={watch('typology') === PROMO_TYPOLOGY_SUBSCRIPTION ? 12 : 6}>
                            <Accordion
                                sx={{border: (ancillariesErrorMessage && Object.keys(ancillariesErrorMessage).length > 0) ? "2px solid " + errorColor : ""}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreRounded/>}
                                    aria-controls="ancillaries-content"
                                    id="ancillaries-header"
                                >
                                    <Typography>{t('promo.ancillaryPromo.title')}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Button
                                        disabled={ancillaryNameList.length === 0 || (ancillaries && ancillaries.some((s: any) => !s.name || (!s.discount && !s.amount)))}
                                        sx={{float: "right"}} variant={"text"} color={"accent"}
                                        endIcon={<LibraryAddRounded/>} onClick={addAncillary}>
                                        {t('promo.ancillaryPromo.add')}
                                    </Button>
                                    {ancillaries && ancillaries.length > 0 &&
                                        <Ancillaries ancillaries={ancillaries}
                                                     ancillaryNameList={ancillaryNameList}
                                                     setAncillaries={setAncillaries}
                                                     errorMessage={ancillariesErrorMessage}
                                                     setErrorMessage={setAncillariesErrorMessage}/>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        {(watch('typology') !== PROMO_TYPOLOGY_SUBSCRIPTION) &&
                            <Grid item xs={6}>
                                <Accordion
                                    sx={{border: (earlyBookingsErrorMessage && Object.keys(earlyBookingsErrorMessage).length > 0) ? "2px solid " + errorColor : ""}}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreRounded/>}
                                        aria-controls="earlyBookings-content"
                                        id="earlyBookings-header"
                                    >
                                        <Typography>{t('promo.earlyBookings.title')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Button
                                            disabled={earlyBookings && earlyBookings.some((s: any) => !s.early || !s.discount)}
                                            sx={{float: "right"}} variant={"text"} color={"accent"}
                                            endIcon={<LibraryAddRounded/>} onClick={addEarlyBooking}>
                                            {t('promo.earlyBookings.add')}
                                        </Button>
                                        {earlyBookings && earlyBookings.length > 0 &&
                                            <EarlyBookings earlyBookings={earlyBookings}
                                                           setEarlyBookings={setEarlyBookings}
                                                           errorMessage={earlyBookingsErrorMessage}
                                                           setErrorMessage={setEarlyBookingsErrorMessage}/>}
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        }
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"}>
                            <Grid item>
                                <Button variant={"outlined"} color={"accent"}
                                        onClick={() => {
                                            navigate("/salesmarketing/promolist")
                                        }}>
                                    {t('promo.buttons.cancel')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button color={"accent"} disabled={disabledConfirm}
                                        type="submit">{t('promo.buttons.confirm')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
               
            </Paper>
            <PromoCreationModal isUpdate={isUpdate} open={openCreationModal}
                                handleCloseCreationModal={() => setOpenCreationModal(false)}/>
            <PromoAddProductModal open={openAddProductModal}
                                  handleClose={() => {
                                      setOpenAddProductModal(false);
                                  }}
                                  categories={categories}
                                  segments={segments}
                                  setValue={setValue}
                                  watch={watch}
            />
        </>
    );
}

export default PromoCreateOrUpdatePage;